import { clamp } from "../../utils/math";
import type { ProfileProgress } from "../progression/levels";
import type { AutoLaunchTicketDefinition, AutoLaunchUpgradeDefinition } from "./catalog";

export function autoLaunchTicketPrice(definition: AutoLaunchTicketDefinition, purchaseCount: number, progress: ProfileProgress): number {
  const longUseRamp = purchaseCount <= 10 ? 1 : 1 + (purchaseCount - 10) * 0.045;
  return roundTicketPrice(definition.basePrice * definition.growth ** purchaseCount * longUseRamp * autoLaunchPrestigeDiscountMultiplier(progress));
}

export function autoLaunchPrestigeDiscountMultiplier(progress: ProfileProgress): number {
  return progress.prestigeLevel > 0 ? clamp(0.65 - (progress.prestigeLevel - 1) * 0.004, 0.5, 0.65) : 1;
}

export function autoLaunchUpgradePrice(definition: AutoLaunchUpgradeDefinition, level: number): number {
  return roundTicketPrice(definition.basePrice * definition.growth ** level * autoUpgradeLateRamp(level));
}

function autoUpgradeLateRamp(level: number): number {
  if (level <= 9) {
    return 1;
  }

  const x = level - 9;
  return 1.33 ** x * (1 + x * 0.13);
}

export function roundTicketPrice(value: number): number {
  if (value < 1_000) return Math.ceil(value / 10) * 10;
  if (value < 10_000) return Math.ceil(value / 50) * 50;
  if (value < 100_000) return Math.ceil(value / 500) * 500;
  if (value < 1_000_000) return Math.ceil(value / 1_000) * 1_000;
  if (value < 10_000_000) return Math.ceil(value / 10_000) * 10_000;
  return Math.ceil(value / 100_000) * 100_000;
}
